import { PHONE_DISPLAY } from "../../constants/contact";

const links = [
  { href: "#diagnosi", label: "Diagnosi Costi", testid: "nav-link-diagnosi" },
  { href: "#attivita", label: "Per il Tuo Settore", testid: "nav-link-settori" },
  { href: "#fedelta", label: "Fidelizzazione", testid: "nav-link-fedelta" },
  { href: "#chiarimenti", label: "Domande", testid: "nav-link-domande" },
];

export function Nav() {
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-[#F6F5F2]/95 backdrop-blur-md border-b border-[#E3DFD7] px-6 py-5"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <svg className="w-7 h-7 text-[#1B4D3E]" viewBox="0 0 28 28" fill="none" aria-hidden="true">
            <circle cx="14" cy="14" r="13" stroke="#1B4D3E" strokeWidth="2" />
            <path d="M8 14H20M14 8V20" stroke="#1B4D3E" strokeWidth="2" strokeLinecap="square" />
          </svg>
          <div>
            <span className="block text-base font-bold tracking-tight text-[#1B4D3E]" data-testid="nav-brand-name">
              Alberto Rameni
            </span>
            <span className="block text-[10px] font-sans tracking-widest uppercase text-[#736F67]">
              Consulenza POS SumUp
            </span>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-8 font-sans text-xs uppercase tracking-widest text-[#5A564F]">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid} className="hover:text-[#1B4D3E] transition-colors">
              {l.label}
            </a>
          ))}
        </div>
        <a
          href="#contatto"
          data-testid="nav-phone-button"
          className="font-sans px-4 py-2 bg-[#1B4D3E] text-[#F6F5F2] rounded text-xs font-bold tracking-wider hover:bg-[#12352B] transition-colors"
        >
          {PHONE_DISPLAY}
        </a>
      </div>
    </nav>
  );
}
